import React from 'react';

export default props => (
    <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <path
            d="M11 46V19.1C7.83333 18.4333 5.29167 17.0083 3.375 14.825C1.45833 12.6417 0.5 10.1 0.5 7.2H3.5C3.5 9.8 4.50833 11.9833 6.525 13.75C8.54167 15.5167 11 16.4 13.9 16.4H18.9C20.1667 16.4 21.1 16.5083 21.7 16.725C22.3 16.9417 23.0667 17.45 24 18.25L33.2 26.85L31.05 29L21.8 20.3V46H18.8V33.25H14V46H11ZM16.404 13.3C15.4013 13.3 14.5417 12.943 13.825 12.229C13.1083 11.515 12.75 10.6566 12.75 9.654C12.75 8.65133 13.107 7.79167 13.821 7.075C14.535 6.35833 15.3934 6 16.396 6C17.3987 6 18.2583 6.357 18.975 7.071C19.6917 7.78503 20.05 8.64337 20.05 9.646C20.05 10.6487 19.693 11.5083 18.979 12.225C18.265 12.9417 17.4066 13.3 16.404 13.3Z"
            fill="#EC9C00"
        />
        <path d="M36.5 46V17.75H29V4H46.5V17.75H39V46H36.5Z" fill="#EC9C00" />
        <path
            d="M38.6999 15.4L43.2999 10.8L38.6999 6.20001L36.8999 8.00001L38.4499 9.55001H31.8999V12.05H38.4499L36.8999 13.6L38.6999 15.4Z"
            fill="white"
        />
    </svg>
);
